import * as actionTypes from '../types'
import {updateObject} from '../../utils/utility'

const initialState = {
    payload: null,
    errors: null,
    isLoading: false,
    isSucceedForAdd: null,
    isSucceedForGetAll: null,
    isSucceedForGet: null,
    isSucceedForPut: null,
    isSucceedForDelete: null,
    uploadProgressingStep: 0,
    isSucceedForCopy: null
};
const addStart = (state, action) => {
    return updateObject(state, {
        isLoading: action.isLoading,
    });
};
export const uploadProgressStart = (state, action) => {
    return updateObject(state, {
      uploadProgressingStep: action.uploadProgressingStep
    });
  };
const addSuccess = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForAdd: action.isSucceedForAdd,
        uploadProgressingStep: action.uploadProgressingStep
    });
};
const addFail = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
        uploadProgressingStep: action.uploadProgressingStep
    });
};
const addReset = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForAdd: action.isSucceedForAdd,
        uploadProgressingStep: action.uploadProgressingStep
    });
};
const getStart = (state, action) => {
    return updateObject(state, {
        isLoading: action.isLoading,
    });
};
const getSuccess = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForGet: action.isSucceedForGet,
    });
};
const getFail = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
    });
};
const getReset = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForGet: action.isSucceedForGet,
    });
};
const getAllStart = (state, action) => {
    return updateObject(state, {
        isLoading: action.isLoading,
    });
};
const getAllSuccess = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForGetAll: action.isSucceedForGetAll,
    });
};
const getAllFail = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
    });
};
const getAllReset = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForGetAll: action.isSucceedForGetAll,
    });
};
const putStart = (state, action) => {
    return updateObject(state, {
        isLoading: action.isLoading,
    });
};
const putSuccess = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForPut: action.isSucceedForPut,
    });
};
const putFail = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
    });
};
const putReset = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForPut: action.isSucceedForPut,
    });
};
const deleteStart = (state, action) => {
    return updateObject(state, {
        isLoading: action.isLoading,
    });
};
const deleteSuccess = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForDelete: action.isSucceedForDelete,
    });
};
const deleteFail = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
    });
};
const deleteReset = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForDelete: action.isSucceedForDelete,
    });
};
const copyStart = (state, action) => {
    return updateObject(state, {
        isLoading: action.isLoading,
    });
};
const copySuccess = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForCopy: action.isSucceedForCopy,
    });
};
const copyFail = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
    });
};
const copyReset = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForCopy: action.isSucceedForCopy,
    });
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.ADD_EDUCATION_START:
            return addStart(state,action);
        case actionTypes.ADD_EDUCATION_UPLOAD_PROGRESS_START:
            return uploadProgressStart(state, action);
        case actionTypes.ADD_EDUCATION_SUCCESS:
            return addSuccess(state,action);
        case actionTypes.ADD_EDUCATION_FAIL:
            return addFail(state,action);
        case actionTypes.ADD_EDUCATION_RESET:
            return addReset(state,action);
        case actionTypes.GET_EDUCATION_START:
            return getStart(state, action);
        case actionTypes.GET_EDUCATION_SUCCESS:
            return getSuccess(state, action);
        case actionTypes.GET_EDUCATION_FAIL:
            return getFail(state, action);
        case actionTypes.GET_EDUCATION_RESET:
            return getReset(state, action);
        case actionTypes.GET_ALL_EDUCATION_START:
            return getAllStart(state, action);
        case actionTypes.GET_ALL_EDUCATION_SUCCESS:
            return getAllSuccess(state, action);
        case actionTypes.GET_ALL_EDUCATION_FAIL:
            return getAllFail(state, action);
        case actionTypes.GET_ALL_EDUCATION_RESET:
            return getAllReset(state, action);
        case actionTypes.PUT_EDUCATION_START:
            return putStart(state, action);
        case actionTypes.PUT_EDUCATION_SUCCESS:
            return putSuccess(state, action);
        case actionTypes.PUT_EDUCATION_FAIL:
            return putFail(state, action);
        case actionTypes.PUT_EDUCATION_RESET:
            return putReset(state, action);
        case actionTypes.DELETE_EDUCATION_START:
            return deleteStart(state, action);
        case actionTypes.DELETE_EDUCATION_SUCCESS:
            return deleteSuccess(state, action);
        case actionTypes.DELETE_EDUCATION_FAIL:
            return deleteFail(state, action);
        case actionTypes.DELETE_EDUCATION_RESET:
            return deleteReset(state, action);
        case actionTypes.COPY_EDUCATION_START:
            return copyStart(state, action);
        case actionTypes.COPY_EDUCATION_SUCCESS:
            return copySuccess(state, action);
        case actionTypes.COPY_EDUCATION_FAIL:
            return copyFail(state, action);
        case actionTypes.COPY_EDUCATION_RESET:
            return copyReset(state, action);
        default:
            return state;
    };
};

export default reducer;